<!--
  - 配药表单
  -->
<template>
  <el-form size="small" label-width="120px">
    <el-form-item label="挂号费用">
      <el-input-number
        v-model="pageData.activeDiagRecord.diagRecord['enrollAmount']"
        :precision="2"
        placeholder="请输入挂号费用"
        disabled
      />
    </el-form-item>
    <el-form-item label="加工费用">
      <el-input-number
        v-model="pageData.activeDiagRecord.diagRecord['decoctPrice']"
        :precision="2"
        placeholder="请输入加工费用"
        disabled
      />
    </el-form-item>
    <el-form-item label="理疗费用">
      <el-input-number
        v-model="pageData.activeDiagRecord.diagRecord['serveAmount']"
        :precision="2"
        placeholder="请输入理疗费用"
        disabled
      />
    </el-form-item>
    <el-form-item label="饮片费用">
      <el-input-number
        v-model="pageData.activeDiagRecord.diagRecord['chmedAmount']"
        :precision="2"
        placeholder="请输入饮片费用"
        disabled
      />
    </el-form-item>
    <el-form-item label="中成药费用">
      <el-input-number
        v-model="pageData.activeDiagRecord.diagRecord['medAmount']"
        :precision="2"
        placeholder="请输入中成药费用"
        disabled
      />
    </el-form-item>
    <el-form-item label="代煎费用">
      <el-input-number
        v-model="pageData.activeDiagRecord.diagRecord['chagentAmount']"
        :precision="2"
        placeholder="请输入代煎费用"
        disabled
      />
    </el-form-item>
    <el-form-item label="代售费用">
      <el-input-number
        v-model="pageData.activeDiagRecord.diagRecord['agentAmount']"
        :precision="2"
        placeholder="请输入代售费用"
        disabled
      />
    </el-form-item>
    <el-form-item label="总费用">
      <el-input-number
        v-model="pageData.activeDiagRecord.diagRecord['sellingAmount']"
        :precision="2"
        placeholder="请输入总费用"
        disabled
      />
    </el-form-item>
  </el-form>
</template>

<script>
export default {
  name: "PrepareMedForm",
  inject: ["pageData"]
}
</script>

<style scoped lang="scss">

</style>
